import { STAGES } from '../config/stages'

// Progress steps for intro path (stages 02, 03)
const INTRO_PROGRESS_STEPS = [
  { 
    id: 'intro',
    label: 'Intro Call', 
    stages: [STAGES.INTEREST_CONFIRMED, STAGES.GENERIC_DEMO] 
  }
]

// Progress steps for personalised path (stages 03B onwards)
const PERSONALISED_PROGRESS_STEPS = [
  { 
    id: 'consent',
    label: 'Consent', 
    stages: [STAGES.CONSENT_INITIATE, STAGES.CONSENT_PENDING, STAGES.CONSENT_SIGNED] 
  },
  { 
    id: 'connect',
    label: 'Connect', 
    stages: [STAGES.API_SETUP, STAGES.API_CONNECTED] 
  },
  { 
    id: 'demo',
    label: 'Demo', 
    stages: [STAGES.DEMO_SCHEDULED] 
  },
  { 
    id: 'complete',
    label: 'Complete', 
    stages: [STAGES.PROVISIONED] 
  }
]

const ProgressIndicator = ({ currentStage }) => {
  // Determine which path user is on
  const isIntroPath = currentStage === STAGES.INTEREST_CONFIRMED || currentStage === STAGES.GENERIC_DEMO
  const steps = isIntroPath ? INTRO_PROGRESS_STEPS : PERSONALISED_PROGRESS_STEPS

  // Find current step index
  const currentStepIndex = steps.findIndex(step => 
    step.stages.includes(currentStage)
  )

  // Intro path is single-step
  if (isIntroPath) {
    const isScheduled = currentStage === STAGES.GENERIC_DEMO
    return (
      <div className="w-full">
        <div className="flex items-center justify-center">
          <div className="flex flex-col items-center">
            <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium ring-4 ${
              isScheduled 
                ? 'bg-accent-500 text-white ring-accent-100' 
                : 'bg-brand-600 text-white ring-brand-100'
            }`}>
              {isScheduled ? (
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              ) : (
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              )}
            </div>
            <span className={`mt-2 text-xs font-medium ${
              isScheduled ? 'text-accent-700' : 'text-brand-700'
            }`}>
              {isScheduled ? 'Intro Scheduled' : 'Book Intro Call'}
            </span>
          </div>
        </div>
      </div>
    )
  }

  // Personalised path - show full progress
  return (
    <div className="w-full">
      <div className="flex items-center justify-between">
        {steps.map((step, index) => {
          const isCompleted = index < currentStepIndex
          const isCurrent = index === currentStepIndex
          const isUpcoming = index > currentStepIndex

          return (
            <div key={step.id} className="flex items-center flex-1">
              {/* Step indicator */}
              <div className="flex flex-col items-center">
                <div
                  className={`
                    w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium
                    transition-all duration-300
                    ${isCompleted 
                      ? 'bg-accent-500 text-white' 
                      : isCurrent 
                        ? 'bg-brand-600 text-white ring-4 ring-brand-100' 
                        : 'bg-slate-200 text-slate-500'
                    }
                  `}
                >
                  {isCompleted ? (
                    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  ) : (
                    index + 1
                  )}
                </div>
                <span 
                  className={`
                    mt-2 text-xs font-medium
                    ${isCurrent ? 'text-brand-700' : isCompleted ? 'text-slate-600' : 'text-slate-400'}
                  `}
                >
                  {step.label}
                </span>
              </div>

              {/* Connector line */}
              {index < steps.length - 1 && (
                <div className="flex-1 mx-2 mt-[-1rem]">
                  <div 
                    className={`
                      h-0.5 transition-all duration-300
                      ${index < currentStepIndex ? 'bg-accent-500' : 'bg-slate-200'}
                    `}
                  />
                </div>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default ProgressIndicator
